module.exports = __webpack_public_path__ + "img/button-center-white.188714a.png";